"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PlayFilledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M6.87468837,5.45041947 L12.7318793,8.46657119 C13.1846512,8.7280426 13.1496124,9.3145752 12.7318793,9.53342881 L6.87468837,12.5495805 C6.53846154,12.7435913 6.00574179,12.5298767 6,12.0161517 L6,5.98384828 C5.99738462,5.60310364 6.38835144,5.22900391 6.87468837,5.45041947 Z" })));
};
PlayFilledSmall.displayName = 'PlayFilledSmall';
exports.default = PlayFilledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PlayFilledSmall.js.map